import { render } from "./HotSection.vue?vue&type=template&id=880654b4&scoped=true"
import script from "./HotSection.vue?vue&type=script&lang=js"
export * from "./HotSection.vue?vue&type=script&lang=js"

import "./HotSection.vue?vue&type=style&index=0&id=880654b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-880654b4"]])

export default __exports__